import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import _ from "underscore";

var ReactTooltip = require("react-tooltip");

var CurrentUser = require("lib/account/CurrentUser");
var DataRouting = require("lib/routing/DataRouting");
var Formats = require("lib/academic/Formats");
var Skillsets = require("lib/academic/Skillsets");
var UIActions = require("lib/actions/UIActions");
var StudentMetrics = require("lib/data/StudentMetrics");

var Glyphicon = require("components/utility/icons/Glyphicon");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");
var StudentDisplay = require("components/users/students/StudentDisplay");
var ScoreDisplay = require("components/writing/evaluations/ScoreDisplay");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var WritingActions = require("lib/actions/WritingActions");
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("writing/activities/teacher_picks_table.scss");

function propsToConditions(props) {
  var conditions = _.pick(props,
    "startDate", "endDate", "textVariety", "textID", "userIDs", "draft", "dueDate"
  );

  conditions.perPage = props.perPage || DataRouting.PER_PAGE;
  conditions.withTotal = true;

  return conditions;
}


@connect(
  (state, props) => ({
    loading: WritingSelectors.isLoadingResponses({ state }),
    books: ReadingSelectors.books({ state }),
    quizzes: WritingSelectors.quizzes({ state }),
    teacherPicks: WritingSelectors.teacherPicksTasks({ state, conditions: propsToConditions(props) }),
    students: RosterSelectors.students({ state })
  }),
  (dispatch, props) => ({
    populateData: () => {
      // TODO: standardize FE requests
      if ($wr.isLargeRequest(props.userIDs)) {
        // define params for quiz call
        var actionFunction = WritingActions.fetchQuizzes
        var conditions = {}
        var embeds = ["quiz.evaluation", "evaluation.score_details"]
        var options = { cache: true, embeds }
        return new Promise(function (resolve, reject) {
          // fetch quizzes
          $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (results) {
            var quizzesPromise = results
            // define params for response call
            actionFunction = WritingActions.fetchResponses
            conditions = _.pick(props,"startDate", "endDate", "textVariety", "textID", "draft", "dueDate");
            options = { cache: true }
            // fetch responses
            $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (second_results) {
              var responsesPromise = second_results
              // define params for task call
              actionFunction = WritingActions.fetchTasks
              options.embeds = ['task.task_items']
              // fetch responses
              $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, function (third_results) {
                var tasksPromise = third_results
                // resolve all promises
                resolve(_.compact(_.flatten(quizzesPromise.concat(responsesPromise, tasksPromise))));
              })
            })
          })
        }).catch(() => console.log("Reading levels and students failed to load"));
      } else {
        var quizes = dispatch(WritingActions.fetchQuizzes({
          conditions: { userIDs: [props.userIDs] },
          embeds: ["quiz.evaluation", "evaluation.score_details"],
          page: (props.page || 1),
          cache: true
        }));

        var responses = dispatch(WritingActions.fetchResponses({
          conditions: propsToConditions(props),
          cache: true
        }))

        var tasks = dispatch(WritingActions.fetchTasks({
          embeds: ['task.task_items'],
          conditions: propsToConditions(props),
          cache: true
        }))

        return Promise.all([responses, tasks, quizes]);
      }
    },
    fetchBook: (textID) => {
      dispatch(ReadingActions.batchFetchBook({ id: textID }))
    },
    toggleExpandedResponse: (responseID) => {
      dispatch(UIActions.toggleExpandedResponse({ responseID: responseID, expanded: true }));
    },
    fetchEvaluation: (evaluationID) => {
      return dispatch((dispatch, getState) => {
        return WritingSelectors.evaluation({ state: getState(), id: evaluationID })
      })
    },
    fetchActivity: (activityID) => {
      dispatch(WritingActions.fetchActivity({ id: activityID, embeds: ["activity.format_summary"] }))
    },
  })
)
@providePopulateData({ waitForLoad: true })
class TeacherPicksTable extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    var studentsWithoutExercises = [];
    // get all userIDs of students who have activities
    var studentsWithExercisesIDs = _.uniq(_.pluck(props.teacherPicks, 'user_id'))
    // check if selected students have activities
    _.each(props.userIDs, userID => {
      if (!_.includes(studentsWithExercisesIDs, userID)) {
        studentsWithoutExercises.push(userID);
      }
    })
    // get book information
    _.each(props.teacherPicks, (item) => {
      if (item.subject_id && item.subject_id !== 'MISSING_TEXT_ID' && item.subject_id !== '') {
        props.fetchBook(item.subject_id)
      }
    })
    this.state = { orderBy: STUDENT_NAME_ORDER, studentsWithoutExercises, studentsWithExercisesIDs }
  }

  renderSortControl(teacherPicksDisplay) {
    if (_.size(_.compact(teacherPicksDisplay))) {
      var orderOptionText = (op) => {
        if (STUDENT_NAME_ORDER === op) {
          return "Student Name";
        } else if (LAST_ACTIVE === op) {
          return "Last Activity";
        } else if (TEACHER_PICKS_COMPLETE === op) {
          return "Teacher Picks Completed";
        } else if (TEACHER_PICKS_INCOMPLETE === op) {
          return "Teacher Picks Incomplete";
        } else if (ASSIGNED_DATE === op) {
          return "Assigned Date";
        } else if (DUE_DATE === op) {
          return "Due Date";
        } else {
          return StudentMetrics.getLabel(op);
        }
      }

      var renderOption = (op) => {
        return (
          <ButtonDropdownOption key={op} className=""
            text={orderOptionText(op)}
            onClick={this.changeSortBy.bind(this, op)}>
          </ButtonDropdownOption>
        );
      }

      var orderOptions = [];

      orderOptions.push(renderOption(STUDENT_NAME_ORDER));
      orderOptions.push(renderOption(LAST_ACTIVE));
      orderOptions.push(renderOption(TEACHER_PICKS_COMPLETE));
      orderOptions.push(renderOption(TEACHER_PICKS_INCOMPLETE));
      orderOptions.push(renderOption(ASSIGNED_DATE));
      orderOptions.push(renderOption(DUE_DATE));

      if (this.props.showGoals) {
        _.each(this.props.expectationMetrics, (metric) => {
          orderOptions.push(renderOption(metric));
        });

      } else {
        _.each(this.props.userMetricsColumns, (metric) => {
          orderOptions.push(renderOption(metric));
        });
      }

      var displayText = orderOptionText(this.state.orderBy);

      return (
        <div className="sortControlContainer hideOnPrint">
          <div className="sortControlCell">
            Sort By: <ButtonDropdown dropdownDisplay="link" text={displayText}> {orderOptions} </ButtonDropdown>
          </div>
        </div>)
    }
  }

  changeSortBy(orderBy) {
    this.setState({ orderBy });
  }

  onCellClick(subjectType, textID, userID) {
    $wr.redirect(DataRouting.getPath(
      { subjectType, textID, userID: userID }
    ));
    $wr.setWindowY(0);
  }

  handleActivityClick(e) {
    if (e.currentTarget.getAttribute('data-response-id')) {
      this.props.toggleExpandedResponse(e.currentTarget.getAttribute('data-response-id'))
    }
  }

  dateFormat(date) {
    let d = new Date(date);
    let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    let mo = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(d);
    let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);

    return `${mo}/${da}/${ye}`
  }

  filterTaskItems(taskItems, key, value) {
    return _.filter(taskItems, (item) => { return item[key] === value })
  }

  handleWritingClick(e) {
    $wr.nope(e);
    if ((e.target.getAttribute('data-text-id'))
      && e.target.getAttribute('data-subject-type')
      && e.target.getAttribute('data-user-id'))
    {
      var viewPath = `/data/${e.target.getAttribute('data-user-id')}/${e.target.getAttribute('data-subject-type')}?text_id=${e.target.getAttribute('data-text-id')}`
      $wr.redirect(viewPath);
    }
  }

  createViewLink(numCompleted, text_id, subject_type, user_id) {
    var viewLink = ''
    if (numCompleted !== 0) {
      var viewLink = (
      <a className={'viewLink'} 
      onClick={this.handleWritingClick} 
      data-subject-type={subject_type} 
      data-text-id={text_id}
      data-user-id={user_id}>View</a>)
    }
    return viewLink
  }

  
// sorts rows in tables
  sortTeacherPicks(userID) {
    var orderBy = this.state.orderBy;
    var teacherPicks = _.where(this.props.teacherPicks, { user_id: userID })
    if (orderBy == TEACHER_PICKS_COMPLETE) {
      teacherPicks = _.sortBy(teacherPicks, (teacherPick) => {
        return teacherPick.draft
      })
    } else if (orderBy == TEACHER_PICKS_INCOMPLETE) {
      teacherPicks = _.sortBy(teacherPicks, (teacherPick) => {
        return teacherPick.draft
      }).reverse()
    } else if (orderBy == DUE_DATE) {
      teacherPicks = _.sortBy(teacherPicks, 'due_date')
    } else {
      teacherPicks = _.sortBy(teacherPicks, ['draft','created_at'])
    }
    return teacherPicks
  }
  // sorts user tables
  sortUserIDs() {
    var orderBy = this.state.orderBy;
    var students = $wr.sortByName(this.props.students, "flexName");
    if (orderBy == LAST_ACTIVE) {
      students = _.sortBy(this.props.students, (student) => {
        return student.last_active || "1970-01-01";
      }).reverse()
    } else if (orderBy == TEACHER_PICKS_COMPLETE) {
      students = _.sortBy(students, (student) => {
        return _.size(_.where(this.props.teacherPicks, { user_id: student.id, draft: false }))
      }).reverse()
    } else if (orderBy == TEACHER_PICKS_INCOMPLETE) {
      students = _.sortBy(students, (student) => {
        return _.size(_.where(this.props.teacherPicks, { user_id: student.id, draft: true }))
      }).reverse()
    } else if (orderBy == ASSIGNED_DATE) {
      students = _.sortBy(students, (student) => {
        var studentTeacherPicks = _.where(this.props.teacherPicks, { user_id: student.id })
        var firstTeacherPickAssigned = _.first(_.sortBy(studentTeacherPicks, 'created_at'))
        return firstTeacherPickAssigned ? firstTeacherPickAssigned.created_at : "1970-01-01";
      })
    } else if (orderBy == DUE_DATE) {
      students = _.sortBy(students, (student) => {
        var studentTeacherPicks = _.where(this.props.teacherPicks, { user_id: student.id })
        var firstTeacherPickAssigned = _.first(_.sortBy(studentTeacherPicks, 'due_date'))
        return firstTeacherPickAssigned ? firstTeacherPickAssigned.due_date : "1970-01-01";
      })
    }
    return _.pluck(students, 'id')
  }

  render() {
    var teacherPicksDisplay = []
    _.each(this.sortUserIDs(), (userID) => {
      var rows = _.map(this.sortTeacherPicks(userID), (task) => {

        var taskItems = task.task_items;

        if (taskItems) {
          var assigned = <td></td>
          if (task.created_at) {
            assigned = <td>{this.dateFormat(task.created_at)}</td>
          }

          var dueDate = <td></td>
          if (task.due_date) {
            dueDate = <td>{this.dateFormat(task.due_date)}</td>
          }

          var textTitle = <td></td>
          if (task.subject_id !== 'MISSING_TEXT_ID' && task.subject_id !== '') {
            var book = _.find(this.props.books, { text_id: task.subject_id })
            if (book) {
              textTitle = <td className='textTitleColumn'>{book.title}</td>
            }
          }

          var quiz = <td></td>
          var quizTaskItem = _.find(taskItems, { subject_type: StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ })
          if (quizTaskItem && quizTaskItem.subject_id !== null) {
            if (!quizTaskItem.draft) {
              var quizMatch = _.find(this.props.quizzes, { id: parseInt(quizTaskItem.subject_id) })
              if (quizMatch && quizMatch.evaluation) {
                var evaluation = this.props.fetchEvaluation(quizMatch.evaluation);
                if (evaluation) {
                  var expandQuizF = this.onCellClick.bind(this, DataRouting.SUBJECT_QUIZZES, quizMatch.text_id, quizMatch.user_id);
                  quiz = (<td className="clickable" onClick = { expandQuizF }>
                            <ScoreDisplay evaluationID={evaluation.id} mode={ScoreDisplay.INLINE_MODE} />
                            <a href="#" className="hideOnPrint" onClick={$wr.preventDefaultBehavior}>View</a>
                          </td>)
                }
              }
            }
          }

          var otherWriting = <td></td>
          var otherWritingTaskItems = _.filter(taskItems, (item) => { return item['subject_type'] !== StudentMetrics.TEACHER_PICKS_SUBJECTS.QUIZ })
          if (otherWritingTaskItems.length) {
            var otherWritingDisplay = []
          
            var exerciseTaskItems = this.filterTaskItems(taskItems, 'subject_type', StudentMetrics.TEACHER_PICKS_SUBJECTS.EXERCISE)
            var pqTaskItems = this.filterTaskItems(taskItems, 'subject_type', StudentMetrics.TEACHER_PICKS_SUBJECTS.PRACTICE_QUESTION)
            var reviewTaskItem = _.first(this.filterTaskItems(taskItems, 'subject_type', StudentMetrics.TEACHER_PICKS_SUBJECTS.REVIEW))
            var meatCogTaskItem = this.filterTaskItems(taskItems, 'subject_type', StudentMetrics.TEACHER_PICKS_SUBJECTS.QUESTION_BUILDER)

            if (pqTaskItems.length) {
              var numAssignedPQs = pqTaskItems.length
              var numCompletedPQs = _.size(this.filterTaskItems(pqTaskItems, 'draft', false))

              var expandQuestionF = $wr.preventDefaultBehavior
              var viewLink = ''
              if (numCompletedPQs > 0) {
                expandQuestionF = this.onCellClick.bind(this, DataRouting.SUBJECT_ANSWERS, pqTaskItems[0].text_id, task.user_id);
                viewLink = <a href="#" className="hideOnPrint viewLink" onClick={$wr.preventDefaultBehavior}>View</a>
              }
              otherWritingDisplay.push(
                <div key={userID + '_pq'} className="clickable" onClick={expandQuestionF}>
                  <span>{numCompletedPQs}/{numAssignedPQs} Questions</span>
                  {viewLink}
                </div>
              )
            }

            if (reviewTaskItem) {
              var completedReview = reviewTaskItem.draft ? 0 : 1
              var expandReviewF = $wr.preventDefaultBehavior
              var viewLink = ''
              if (completedReview > 0) {
                expandReviewF = this.onCellClick.bind(this, DataRouting.SUBJECT_REVIEWS, reviewTaskItem.text_id, reviewTaskItem.user_id);
                viewLink = <a href="#" className="hideOnPrint viewLink" onClick={$wr.preventDefaultBehavior}>View</a>
              }
              otherWritingDisplay.push(
                <div key={userID + '_review'} onClick={expandReviewF}>
                  <span>{completedReview}/{1} Review</span>
                  {viewLink}
                </div>)
            }

            if (exerciseTaskItems.length) {
              var numAssignedExercises = exerciseTaskItems.length
              var numCompletedExercises = _.size(this.filterTaskItems(exerciseTaskItems, 'draft', false))

              var expandExercisesF = $wr.preventDefaultBehavior
              var viewLink = ''
              if (numCompletedExercises > 0) {
                expandExercisesF = this.onCellClick.bind(this, DataRouting.SUBJECT_ACTIVITIES, exerciseTaskItems[0].text_id, exerciseTaskItems[0].user_id);
                viewLink = <a href="#" className="hideOnPrint viewLink" onClick={$wr.preventDefaultBehavior}>View</a>
              }

              otherWritingDisplay.push(
                <div key={userID + '_exercise'} onClick={expandExercisesF}>
                  <span>{numCompletedExercises}/{numAssignedExercises} Exercises</span>
                  {viewLink}
                </div>)
            }
            // caluclate and display number of question builders assigned
            if (meatCogTaskItem.length) {
              var numAssignedQBs = meatCogTaskItem.length
              var numCompletedQBs = _.size(this.filterTaskItems(meatCogTaskItem, 'draft', false))

              var expandQBsF = $wr.preventDefaultBehavior
              var viewLink = ''
              if (numCompletedQBs > 0) {
                expandQBsF = this.onCellClick.bind(this, DataRouting.SUBJECT_QUESTION_BUILDERS, meatCogTaskItem[0].text_id, meatCogTaskItem[0].user_id);
                viewLink = <a href="#" className="hideOnPrint viewLink" onClick={$wr.preventDefaultBehavior}>View</a>
              }

              otherWritingDisplay.push(
                <div key={userID + '_qb'} onClick={expandQBsF}>
                  <span>{numCompletedQBs}/{numAssignedQBs} Builders</span>
                  {viewLink}
                </div>)
            }

            if (otherWritingDisplay.length) {
              otherWriting = (
                <td className='otherWritingContainer' key={String(userID)}>
                  {otherWritingDisplay}
                </td>
              )
            }
          }

          var hideClass = taskItems.length === 0 ? 'hide-glyphicon' : ''
          var complete = <td className={'iconContainer ' + hideClass}><Glyphicon icon='glyphicon glyphicon-unchecked icon-gray' /></td>
          var completedTaskItems = _.size(_.where(taskItems, { draft: false }))
          if (completedTaskItems === _.size(taskItems)) {
            complete = (
              <td className={'iconContainer ' + hideClass}>
                <Glyphicon icon='glyphicon glyphicon-check icon-green' />
              </td>)
          }

          return (
            <tr key={task.id + '_' + task.user_id + '_' + task.receivedAt}>
              {assigned}
              {dueDate}
              {textTitle}
              {quiz}
              {otherWriting}
              {complete}
            </tr>
          )
        }
      });
      rows = _.compact(rows);

      var studentTable = ''
      if (rows.length) {
        studentTable = (
          <div className="teacherPicksTableContainer" key={userID.toString()}>
            <StudentDisplay studentID={userID} showAvatar avatarMaxWidth={40} />
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th data-tip="Most recent date of any activity during time period">
                    Assigned
							    </th>
                  <th className="dueDateCol">
                    Due Date
							    </th>
                  <th className="textTitleCol">
                    Text Title
							    </th>
                  <th className="quizCol">
                    Quiz
							    </th>
                  <th className="otherWritingCol">
                    Other Writing
							    </th>
                  <th className="completeCol">
                    Complete
							    </th>
                </tr>
                {rows}
              </tbody>
            </table>
          </div>
        );
      }
      teacherPicksDisplay.push(studentTable)
    })

    var noExercises = ''
    if (this.state.studentsWithoutExercises.length) {
      noExercises = <NoActivityBlock userIDs={this.state.studentsWithoutExercises} contentType="Exercises" />
    }

    if (_.size(this.state.studentsWithExercisesIDs) + _.size(this.state.studentsWithoutExercises) === _.size(this.props.userIDs)) {
      return (
        <div className="teacherPicksTable" key={this.props.key}>
            {this.renderSortControl(teacherPicksDisplay)}
            {teacherPicksDisplay}
            {noExercises}
        </div>
      )
    } else {
      return null
    }
  }
}

var LAST_ACTIVE = "last-active";
var STUDENT_NAME_ORDER = "student-name";
var TEACHER_PICKS_COMPLETE = "teacher-picks-complete";
var TEACHER_PICKS_INCOMPLETE = "teacher-picks-incomplete";
var ASSIGNED_DATE = "assigned-date";
var DUE_DATE = "due-date";

TeacherPicksTable.WrappedComponent.propTypes = StrictPropTypes({
  userIDs: PropTypes.array,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  textVariety: PropTypes.string,
  textID: PropTypes.string,
  quizzes: PropTypes.array,
  students: PropTypes.array,
  fetchEvaluation: PropTypes.func,
  fetchActivity: PropTypes.func,
  books: PropTypes.array,
  teacherPicks: PropTypes.array,
  studentList: PropTypes.string,
  loading: PropTypes.bool,
  showFullData: PropTypes.bool,
  draft: PropTypes.bool,
  dueDate: PropTypes.string,
  populateData: PropTypes.func,
  fetchBook: PropTypes.func,
  toggleExpandedResponse: PropTypes.func,
});

module.exports = TeacherPicksTable


// WEBPACK FOOTER //
// ./modules/components/writing/activities/TeacherPicksTable.js